export interface IpAsset {
  id: string;
  type: 'Patente' | 'Software' | 'Secreto';
  title: string;
  status: 'Presentada' | 'Concedida' | 'Abandonada';
  criticalDate: string;
  linkedProjectId: string;
  description?: string;
}

export const mockIpAssets: IpAsset[] = [
  {
    id: 'ip-001',
    type: 'Patente',
    title: 'Sistema y Método de Diagnóstico Médico Asistido por IA',
    status: 'Presentada',
    criticalDate: '2025-01-15T00:00:00Z',
    linkedProjectId: 'proy-001',
    description: 'Patente de invención para el sistema de diagnóstico médico.'
  },
  {
    id: 'ip-002',
    type: 'Software',
    title: 'Plataforma Blockchain AgriTrace',
    status: 'Concedida',
    criticalDate: '2026-03-20T00:00:00Z',
    linkedProjectId: 'proy-002',
    description: 'Registro de software para la plataforma de trazabilidad.'
  },
  {
    id: 'ip-003',
    type: 'Patente',
    title: 'Algoritmo de Optimización Energética Predictiva',
    status: 'Concedida',
    criticalDate: '2027-08-05T00:00:00Z',
    linkedProjectId: 'proy-003',
    description: 'Patente concedida para el algoritmo de optimización.'
  },
  {
    id: 'ip-004',
    type: 'Patente',
    title: 'Biosensor Nanotecnológico para Detección de Contaminantes',
    status: 'Concedida',
    criticalDate: '2028-06-10T00:00:00Z',
    linkedProjectId: 'proy-004',
    description: 'Patente concedida para el biosensor.'
  },
  {
    id: 'ip-005',
    type: 'Software',
    title: 'EduAR - Plataforma de Realidad Aumentada Educativa',
    status: 'Presentada',
    criticalDate: '2025-02-01T00:00:00Z',
    linkedProjectId: 'proy-005',
    description: 'Registro de software en proceso.'
  },
  {
    id: 'ip-006',
    type: 'Secreto',
    title: 'Fórmula de Material Compuesto EcoBuild',
    status: 'Concedida',
    criticalDate: '2025-12-31T00:00:00Z',
    linkedProjectId: 'proy-006',
    description: 'Secreto industrial protegido.'
  }
];
